export default {"src":"/_next/static/media/ico-ausl.5875ebb8.svg","height":50,"width":62,"blurWidth":0,"blurHeight":0};